"use client";

import { PublicSiteHeader } from "@/components/shared/public-site-header";

interface HomepageHeaderProps {
  onScrollLockChange?: (locked: boolean) => void;
  /** The homepage's own anchor scroll (Lenis, 88px offset). */
  onSectionNavigate?: (target: HTMLElement) => void;
}

export function HomepageHeader({ onScrollLockChange, onSectionNavigate }: HomepageHeaderProps) {
  return (
    <PublicSiteHeader
      homeHref="#top"
      onScrollLockChange={onScrollLockChange}
      onSectionNavigate={onSectionNavigate}
      sectionHrefPrefix=""
      surface="adaptive"
    />
  );
}
